// extracted by mini-css-extract-plugin
module.exports = {"newsletterGroup":"Newsletter__newsletterGroup--1nmEG","bounce":"Newsletter__bounce--1Ht-p"};